var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"text-left"},[_vm._v(" Mon Profil d'Administrateur ")]),_c('v-card-actions',[_c('Navigation',{attrs:{"elements":_vm.AdminNavigation}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }